export const CompanyLogo = ({ url }) => (
    <img id="companyLogo" src={url} alt="C4W Logo" className="desktop-only" />
);
